/**
 *
 * @module events/group/extender
 * @author Adam Pirani [adam.pirani@mlb.com]
 * @description extended/custom events
 *
 */

/**
 *
 * @function eventGroup
 * @param {Object} master
 * @param {Object} model
 * @param {Object} viewModel
 *
 */
function eventGroup(master = {}, model = {}, viewModel = {}) {

    /**
     *
     * @event video-started
     * @description dispatched from scores wrapper/embedder when video is played
     *
     */
    master.on('video-started', () => {
        viewModel.emit('video-started');
    });

    /**
     *
     * @event change-selection
     * @description dispatched when game-info toggle is clicked
     *
     */
    viewModel.on('toggle-game-info', () => {
        viewModel.onToggleGameInfo();
    });

    /**
     *
     * @event video-started
     * @description dispatched from master, remove autoplay for that video
     *
     */
    viewModel.on('video-started', () => {
        viewModel.onVideoStarted();
    });

}

export default eventGroup;
